"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectUserManagement = undefined;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _ProjectUtil = require("../../utils/ProjectUtil");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reduxConnect = require("redux-connect");

var _reactRouter = require("react-router");

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _reduxForm = require("redux-form");

var _ProjectUsersEdit = require("../../components/projects/ProjectUsersEdit");

var _ProjectUsersEdit2 = _interopRequireDefault(_ProjectUsersEdit);

var _projects = require("../../redux/modules/projects");

var _ProjectUsersList = require("../../components/projects/ProjectUsersList");

var _ProjectUsersList2 = _interopRequireDefault(_ProjectUsersList);

var _ProjectDriversList = require("../../components/projects/ProjectDriversList");

var _ProjectDriversList2 = _interopRequireDefault(_ProjectDriversList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectUserManagement = exports.ProjectUserManagement = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProjectUserManagement, _Component);

  function ProjectUserManagement() {
    (0, _classCallCheck3.default)(this, ProjectUserManagement);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProjectUserManagement.__proto__ || (0, _getPrototypeOf2.default)(ProjectUserManagement)).call(this));

    _this.state = {
      isAdmin: false
    };
    return _this;
  }

  (0, _createClass3.default)(ProjectUserManagement, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          user = _props.user,
          projectUsers = _props.projectUsers;


      this.setState({ isAdmin: (0, _ProjectUtil.isProjectAdmin)(projectUsers, user.id) });
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          user = _props2.user,
          company = _props2.company,
          projectInactiveUsers = _props2.projectInactiveUsers,
          updateProjectUserByEmail = _props2.updateProjectUserByEmail,
          updateProjectDriverByEmail = _props2.updateProjectDriverByEmail,
          project = _props2.project,
          projectDrivers = _props2.projectDrivers,
          projectUsers = _props2.projectUsers;
      // console.info('projectDrivers', projectDrivers);


      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Proketin j\xE4senet" }),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(
              "h1",
              { className: "h2" },
              company.name,
              ": ",
              project.name,
              " "
            ),
            _react2.default.createElement(
              "b",
              null,
              this.state.isAdmin ? "Ylläpitäjä " : ""
            )
          )
        ),
        _react2.default.createElement(
          "h2",
          { className: "h4 form-title" },
          "Projektin aktiiviset k\xE4ytt\xE4j\xE4t"
        ),
        _react2.default.createElement(_ProjectUsersList2.default, {
          isAdmin: this.state.isAdmin,
          userList: projectUsers,
          updateProjectUserByEmail: updateProjectUserByEmail
        }),
        _react2.default.createElement(
          "h2",
          { className: "h4 form-title" },
          "Projektiin kutsutut k\xE4ytt\xE4j\xE4t"
        ),
        _react2.default.createElement(_ProjectUsersList2.default, {
          isAdmin: this.state.isAdmin,
          userList: projectInactiveUsers,
          updateProjectUserByEmail: updateProjectUserByEmail
        }),
        this.state.isAdmin ? _react2.default.createElement(
          "h2",
          { className: "h4 form-title" },
          "Kutsu k\xE4ytt\xE4ji\xE4 projektiin:"
        ) : "",
        this.state.isAdmin ? _react2.default.createElement(_ProjectUsersEdit2.default, this.props) : "",
        _react2.default.createElement(
          "h2",
          { className: "h4 form-title" },
          "Ilmoitusten kuljettajat"
        ),
        _react2.default.createElement(
          "p",
          null,
          " T\xE4ss\xE4 n\xE4yt\xF6ss\xE4 ei voi muokata kuljettajia, kuljettajat lis\xE4t\xE4\xE4n  ilmoituksen yhteydess\xE4."
        ),
        _react2.default.createElement(_ProjectDriversList2.default, {
          userList: projectDrivers,
          updateProjectDriverByEmail: updateProjectDriverByEmail,
          projectId: project.project_id
        }),
        _react2.default.createElement(
          "div",
          { className: "row" },
          this.showProjektLink()
        )
      );
    }
  }, {
    key: "showProjektLink",
    value: function showProjektLink() {
      var project = this.props.project;

      if (project) {
        var projectUrl = "/projekti/" + project.project_id;
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "p",
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: projectUrl },
              "Siirry projekin sivulle"
            ),
            " "
          )
        );
      }
    }
  }]);
  return ProjectUserManagement;
}(_react.Component), _class.propTypes = {
  user: _react.PropTypes.object,
  company: _react.PropTypes.object,
  project: _react.PropTypes.object,
  projectUsers: _react.PropTypes.array,
  projectDrivers: _react.PropTypes.array,
  projectInactiveUsers: _react.PropTypes.array,
  fields: _react.PropTypes.object.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired
  //     onSubmit: PropTypes.func.isRequired,
}, _temp);
exports.default = (0, _reduxConnect.asyncConnect)([{

  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        id = _ref.params.id;

    var promises = [];
    promises.push(dispatch((0, _projects.loadProject)(id)));
    promises.push(dispatch((0, _projects.loadProjectUsers)(id)));
    promises.push(dispatch((0, _projects.projectGetDrivers)(id)));
    promises.push(dispatch((0, _projects.loadProjectInactiveUsers)(id)));

    return _promise2.default.all(promises);
  }

}])((0, _reactRedux.connect)(function (state) {
  return {
    project: state.projects.project,
    user: state.auth.user,
    company: state.company.company,
    projectUsers: state.projects.projectUsers,
    projectDrivers: state.projects.projectDrivers,
    projectInactiveUsers: state.projects.projectInactiveUsers,
    projects: state.projects

  };
}, {
  loadProject: _projects.loadProject,
  isProjectLoaded: _projects.isProjectLoaded,
  loadProjectUsers: _projects.loadProjectUsers,
  projectGetDrivers: _projects.projectGetDrivers,
  loadProjectInactiveUsers: _projects.loadProjectInactiveUsers,
  updateProjectUserByEmail: _projects.updateProjectUserByEmail,
  updateProjectDriverByEmail: _projects.updateProjectDriverByEmail,
  pushRoute: _reactRouterRedux.push
})((0, _reduxForm.reduxForm)({
  form: "ads",
  fields: ["emails", "is_admin", "is_project_editor", "is_driver", "is_admin"],
  initialValues: {
    is_driver: false
  }
})(ProjectUserManagement)));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Projects/ProjectUserManagement.js
 ** module id = 1235
 ** module chunks = 0
 **/